export default __webpack_public_path__ + "static/Visiomate_MMG_Case_Study-e67185000a0ba5d5e82312f8d04e5fe2.pdf";